import { Dispatch, ReactNode, SetStateAction } from 'react';
import MyModal from '../../../../../components/Modal';
import { LineBeingDeletedType } from '../../types';
import CardDelete from './components/CardDelete';

interface DeleteModalInterface {
  lineBeingDeleted: LineBeingDeletedType;
  setDeleteModalShow: Dispatch<SetStateAction<boolean>>;
  deleteLine: () => void;
  deleteModalShow: boolean;
  directionTagLiterals: { [key: number]: ReactNode };
}

export default function DeleteModal({
  lineBeingDeleted,
  setDeleteModalShow,
  deleteLine,
  deleteModalShow,
  directionTagLiterals,
}: DeleteModalInterface) {
  return (
    <MyModal
      title={`Excluir linha ${lineBeingDeleted.lineCode}`}
      closeButtonLabel="Cancelar"
      actionButtonLabel="Excluir"
      modalBody={
        <CardDelete
          directionTagLiterals={directionTagLiterals}
          lineBeingDeleted={lineBeingDeleted}
        />
      }
      onClose={() => setDeleteModalShow(false)}
      onAction={() => deleteLine()}
      show={deleteModalShow}
      type="deleteAction"
      size='lg'
    />
  );
}
